module.exports = __webpack_public_path__ + "img/jan2022challenge.9d2dc2b9.png";